import { type ITooltipProps } from 'shared/ui'
import type { IPermissions } from 'entities/Permissions'
import { type IPermissionsContactAccess } from 'entities/Users'

type IPermissionsRolesOptions = {
  key: string
  label: string
  permissions: {
    key: keyof IPermissions
    label: string
    tooltip?: {
      label: React.ReactNode
      tooltipProps?: ITooltipProps
    }
    value?: IPermissionsContactAccess
    type: 'checkbox' | 'radio'
  }[]
}[]

export const PERMISSIONS_ROLES_OPTIONS: IPermissionsRolesOptions = [
  {
    key: 'functionalityAccess',
    label: 'Functionality access',
    permissions: [
      {
        key: 'broadcasts',
        label: 'Can access Broadcasts',
        type: 'checkbox',
      },
      {
        key: 'campaigns',
        label: 'Can access Campaigns',
        type: 'checkbox',
      },
      {
        key: 'textBot',
        label: 'Can access AI Agent',
        type: 'checkbox',
      },
      {
        key: 'triggers',
        label: 'Can access Triggers',
        type: 'checkbox',
      },
      {
        key: 'reportingAndAnalytics',
        label: 'Can access Analytics',
        type: 'checkbox',
      },
      {
        key: 'phoneChecker',
        label: 'Can access PhoneCheckr',
        type: 'checkbox',
      },
      {
        key: 'cannedMessage',
        label: 'Can access Saved Replies',
        type: 'checkbox',
      },
    ],
  },
  {
    key: 'contactsManagement',
    label: 'Contacts management',
    permissions: [
      {
        key: 'contactCreate',
        label: 'Can create Contacts',
        type: 'checkbox',
      },
    ],
  },
  {
    key: 'contactsAccess',
    label: 'Contacts access',
    permissions: [
      {
        key: 'contactAccess',
        label: 'Can access all contacts',
        value: 'can_access_all',
        type: 'radio',
      },
      {
        key: 'contactAccess',
        label: 'Can access contacts assigned to their team',
        value: 'can_access_groups',
        type: 'radio',
      },
      {
        key: 'contactAccess',
        label: 'Can access contacts assigned to them',
        value: 'can_access_own',
        type: 'radio',
      },
    ],
  },
  {
    key: 'inboxManagement',
    label: 'Inbox management',
    permissions: [
      {
        key: 'inbox',
        label: 'Can manage Inboxes',
        type: 'checkbox',
      },
      {
        key: 'transferConversation',
        label: 'Can transfer Conversations',
        type: 'checkbox',
      },
      {
        key: 'reassignConversation',
        label: 'Can reassign Conversations',
        type: 'checkbox',
      },
    ],
  },
  {
    key: 'dataAndSecurity',
    label: 'Data & Security',
    permissions: [
      {
        key: 'dataAndSecurity',
        label: 'Can manage Data & Security',
        tooltip: {
          label: (
            <>
              Can import and export contacts
              <br />
              Can manage security settings
            </>
          ),
        },
        type: 'checkbox',
      },
      {
        key: 'billing',
        label: 'Can manage Billing',
        type: 'checkbox',
      },
      {
        key: 'members',
        label: 'Can manage Members',
        type: 'checkbox',
      },
      {
        key: 'manualOptIn',
        label: 'Can access Manual Opt-In',
        type: 'checkbox',
      },
    ],
  },
]
